import BaseModel from './BaseModel';

class QuestionnairesRepositoryMetadataEntry extends BaseModel {}

QuestionnairesRepositoryMetadataEntry.collection =
  'QuestionnairesRepositoryMetadata';

export default QuestionnairesRepositoryMetadataEntry;
